export default __webpack_public_path__ + "static/garage-95e327278eaffb3d9bb7453fa546eefd.gif";